import { render, staticRenderFns } from "./ArticleImage.vue?vue&type=template&id=34498828"
import script from "./ArticleImage.vue?vue&type=script&lang=js"
export * from "./ArticleImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports